import styled from 'styled-components';

export const FeaturedBlock = styled.section``;

export const FeaturedCard = styled.div`
  position: relative;
  &.is-about {
    @media (min-width: 768px) {
      margin-top: 100px !important;
      margin-bottom: 50px !important;
    }

    @media (max-width: 767px) {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }
  }
  /* &.is-virtual {
    @media (min-width: 1199px) {
      h2 {
        width: 80%;
        margin: 0px auto;
      }
    }

    @media (min-width: 768px) {
      margin-top: 100px !important;
      margin-bottom: 50px !important;
    }

    @media (max-width: 767px) {
      margin-top: 20px !important;
      margin-bottom: 20px !important;
    }
  } */

  @media (min-width: 768px) {
    margin: 50px 0 0;
  }

  @media (max-width: 767px) {
    margin: 20px 0 0;
  }

  img {
    transition: 0.5s;

    @media (min-width: 1280px) {
      height: auto;
      width: 100%;
    }

    @media (max-width: 1279px) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`;

export const FeaturedImage = styled.div`
  position: relative;
  width: 100%;
  height: 495px;
  overflow: hidden;

  span {
    @media (min-width: 768px) {
      height: 100%;
      object-fit: cover;
    }

    &.lazy-load-image-background {
      display: block !important;
      height: 100%;

      img {
        transition: 0.5s !important;
      }
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }

  div {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 1199px) {
    height: 400px;
  }

  @media (max-width: 991px) {
    height: 300px;
  }
`;

export const FeaturedText = styled.div`
  z-index: 2;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 0;
  height: 100%;
  display: flex;
  text-align: center;
  flex-flow: column;
  justify-content: center;
  color: #fff;

  @media (min-width: 1200px) {
    width: 70%;
  }

  @media (min-width: 1280px) {
    width: 60%;
  }

  p {
    color: #fff;
    text-transform: uppercase;
    height: 180px;
    margin: 0;
    display: flex;
    justify-content: center;
    flex-flow: column;
    font-size: ${({ dir }) => (dir === 'rtl' ? '20px' : '')};
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif ' : '')};
  }

  h2 {
    margin-bottom: 0;
  }

  @media (max-width: 1199px) {
    p {
      height: 120px;
    }
  }

  @media (max-width: 1199px) {
    width: 80%;

    p {
      display: none;
    }

    h2 {
      margin-bottom: 2rem;
    }
  }

  @media (max-width: 767px) {
    width: 75%;
  }

  &.ctatext {
    h2 {
      @media (min-width: 1200px) {
        line-height: 40px;
      }

      @media (max-width: 768px) {
        font-size: 20px;
      }
    }
  }

  &[dir='rtl'] {
    p {
      line-height: 25px;
    }
  }
`;
